// Mock data for Kanzlei Nabhan Gäbler & Partner website

export const navLinks = [
  { label: 'START', href: '/' },
  { label: 'KARRIERE', href: '/karriere' },
  { label: 'DOWLOADS', href: '/downloads' },
  { label: 'KONTAKT', href: '/#kontakt' },
  { label: 'MANDANTENERFASSUNG', href: '/mandantenerfassung' },
  { label: 'SEPA-Lastschrift', href: '/sepa-lastschrift' },
];

export const specialAreas = [
  {
    title: 'AUSLÄNDERRECHT',
    items: [
      'EINBÜRGERUNGSVERFAHREN',
      'FAMILIENNACHZUG',
      'AUFENTHALTSERLAUBNIS',
      'AUSSETZUNG DER ABSCHIEBUNG',
      'ARBEITSERLAUBNIS',
    ],
  },
  {
    title: 'STRAFRECHT',
    items: [
      'STRAFVERTEIDIGUNG',
      'BTMG-SACHEN',
      'WIRTSCHAFTS- & STEUERSTRAFTATEN',
      'KAPITALSTRAFSACHEN',
    ],
  },
  {
    title: 'STEUERBERATUNG',
    items: [
      'STEUERLICHE BERATUNG',
      'INTERNATIONALE BESTEUERUNG',
      'FINANZBUCHHALTUNG',
      'LOHNBUCHHALTUNG',
      'STEUERERKLÄRUNGEN',
      'JAHRESABSCHLÜSSE',
    ],
  },
  {
    title: 'STEUERRECHT',
    items: [
      'BETRIEBSPRÜFUNGEN',
      'STEUERSTRAFVERFAHREN',
      'EINSPRUCHVERFAHREN',
      'VERTRETUNG VOR FINANZGERICHTEN',
    ],
  },
  {
    title: 'GESELLSCHAFTSRECHT',
    items: [
      'GESELLSCHAFTSVERTRÄGE',
      'BETRIEBSWIRTSCHAFTLICHE GUTACHTEN',
      'GRÜNDUNGSBERATUNG',
    ],
  },
  {
    title: 'VERWALTUNGSRECHT',
    items: [
      'SOZIALRECHT',
      'ORDNUNGSWIDRIGKEITEN',
      'LEISTUNGSBEZUG',
    ],
  },
  {
    title: 'MIETRECHT',
    items: [
      'MIETMINDERUNG & MÄNGELRÜGE',
      'KÜNDIGUNGSSCHUTZ',
      'BETRIEBSKOSTENABRECHNUNG',
      'EIGENBEDARFSKÜNDIGUNG',
      'KAUTION & RÜCKZAHLUNG',
    ],
  },
  {
    title: 'VERKEHRSRECHT',
    items: [
      'UNFALLREGULIERUNG',
      'FAHRVERBOT & PUNKTE',
      'BUSSGELDBESCHEIDE',
      'FÜHRERSCHEINENTZUG',
      'MPU-BEGLEITUNG',
    ],
  },
];

export const expertiseList = [
  'AUSLÄNDERRECHT',
  'STEUERRECHT',
  'MIETRECHT',
  'VERKEHRSRECHT',
  'STRAFRECHT',
  'VERWALTUNGSRECHT',
  'GESELLSCHAFTSRECHT',
];

export const partners = [
  {
    name: 'SIMON NABHAN',
    role: 'PARTNER',
    phone: '+49(0)228 30 40 64-0',
    email: 'nabhan@kanzlei-partner.com',
    image: '/assets/team/simon-nabhan.png',
  },
  {
    name: 'GERD GÄBLER',
    role: 'PARTNER',
    phone: '+49(0)228 30 40 64-0',
    email: 'gaebler@kanzlei-partner.com',
    image: '/assets/team/gerd-gaebler.jpg',
    objectPosition: 'center 20%',
  },
  {
    name: 'CHRISTIAN NABHAN',
    role: 'PARTNER',
    phone: '+49(0)228 30 40 64-0',
    email: 'c.nabhan@kanzlei-partner.com',
    image: '/assets/team/christian-nabhan.png',
  },
];

export const heroImage = '/assets/hero.jpg';
export const visionImage = 'https://images.unsplash.com/photo-1521791136064-7986c2920216?w=1200&q=80';

export const visionParagraphs = [
  'Als Experten für Steuern und Recht sind wir Ihr verlässlicher Partner in einer zunehmend komplexen und sich ständig wandelnden Gesetzgebung. Unser Ziel ist es, Ihnen dabei zu helfen, Ihre finanziellen und rechtlichen Herausforderungen erfolgreich zu meistern, damit Sie sich auf das konzentrieren können, was für Sie am wichtigsten ist.',
  'Mit unserer langjährigen Erfahrung und fundierten Fachkenntnissen unterstützen wir sowohl Privatpersonen als auch Unternehmen in den Bereichen Steuerplanung, Rechtsberatung, Buchhaltung und Compliance. Wir sind stets auf dem neuesten Stand der Gesetzgebung und nutzen moderne Technologien, um effiziente, maßgeschneiderte Lösungen für unsere Mandanten zu entwickeln.',
  'In unserer Kanzlei legen wir größten Wert auf persönliche Betreuung und individuelle Beratung. Wir nehmen uns die Zeit, Ihre individuellen Bedürfnisse und Ziele zu verstehen, um Ihnen eine umfassende, auf Sie zugeschnittene Beratung anzubieten. Unser Team aus erfahrenen Rechtsanwälten, Betriebswirten und Fachexperten steht Ihnen jederzeit zur Verfügung, um Sie in allen steuerlichen und rechtlichen Fragestellungen zu unterstützen.',
  'Gemeinsam navigieren wir durch das Labyrinth der Gesetze und Vorschriften, damit Sie Ihre finanziellen und rechtlichen Angelegenheiten erfolgreich bewältigen können. Lassen Sie uns Ihnen helfen, eine solide Basis für Ihren Erfolg zu schaffen und Ihre Ziele zu erreichen.',
];

export const contactInfo = {
  address: 'Bundeskanzlerplatz 2D, D-53113 Bonn',
  email: 'BONN@KANZLEI-PARTNER.COM',
  phone: '+49 (0) 228 30 40 640',
};
